// extracted by mini-css-extract-plugin
export var imageLegend = "image-compare-with-legend-module--imageLegend--17n2O";
export var outerMargin = "image-compare-with-legend-module--outerMargin--SZTkW";
export var rightAlign = "image-compare-with-legend-module--rightAlign--ZRmV8";
export var yearLabelContainer = "image-compare-with-legend-module--yearLabelContainer--tAzm1";